import React from 'react';
import { DnsRecordCodeCell } from '../components/DnsRecordCodeCell/DnsRecordCodeCell';
import { DnsRecordStatusCell } from '../components/DnsRecordStatusCell/DnsRecordStatusCell';
import { DnsRecordValueCell } from '../components/DnsRecordValueCell/DnsRecordValueCell';
export const getTableHeaders = (isVerificationInProgress) => [
    {
        id: 'type',
        label: 'TYPE',
        render: ({ recordType }) => recordType,
        width: 1,
    },
    {
        id: 'host',
        label: 'HOST',
        render: ({ alias, zoneFile }) => (React.createElement(DnsRecordCodeCell, { value: zoneFile?.hostLabel || '', recordAlias: alias })),
        width: 5,
    },
    {
        id: 'value',
        label: 'VALUE',
        render: (record) => React.createElement(DnsRecordValueCell, { record: record }),
        width: 5,
    },
    {
        id: 'status',
        label: '',
        render: (record) => (React.createElement(DnsRecordStatusCell, { record: record, isVerificationInProgress: isVerificationInProgress })),
        width: 1,
        alignment: 'right',
    },
];
